module.exports = __webpack_public_path__ + "img/menu_logout.ad885562.png";